






























import FullCalendar, { Calendar, CalendarOptions } from '@fullcalendar/vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollGrid from '@fullcalendar/scrollgrid';
import moment from 'moment';
import PropPopover from '@shared/components/help/prop-popover.vue';

interface CalendarItem {
  dateTime: string;
  color: string;
  class: string;
  title: string;
}

interface CalendarBackgroundItem {
  dateTime: string;
  color: string;
  class: string;
  title: string;
  // Maybe add more
}

@Component({
  name: 'bpc-weekly-calendar',
  components: {
    FullCalendar,
  },
})
export default class WeeklyCalendar extends Vue {
  $refs: {
    fcalendar: InstanceType<typeof FullCalendar> & {
      $emit(event): void;
      getApi(): Calendar;
    };
  };
  // PROPS
  @Prop({
    type: String,
    default() {
      return moment().format('YYYY-MM-DD');
    },
  })
  readonly date: string;
  @Prop({
    type: String,
    default: 'bpc-weekly-calendar__id',
  })
  readonly calendarId: string;
  @Prop({
    type: Function,
    default(info) {
      return `<div class="event-title">${info.event.title}</div>`;
    },
  })
  readonly getPopoverTitleStr: (info) => string;
  @Prop({
    type: Function,
    default(info) {
      return `<div class="event-time">${info.timeText}</div>`;
    },
  })
  readonly getPopoverContentStr: (info) => string;
  @Prop({
    type: Boolean,
  })
  readonly withPopover: boolean;
  @Prop({
    type: Boolean,
  })
  readonly disableDragAndDrop: boolean;
  @Prop({
    type: Boolean,
  })
  readonly disableResize: boolean;
  @Prop({
    type: Boolean,
  })
  readonly disableEdit: boolean;
  @Prop({
    type: Boolean,
  })
  readonly disableSelect: boolean;
  @Prop({
    type: Boolean,
  })
  readonly disableOverlap: boolean;
  @Prop({
    type: Number,
    default: 100,
  })
  readonly dayMinWidth: number;
  @Prop({
    type: Number,
  })
  readonly slotDuration: number; // NOTE: in minutes
  @Prop({
    type: String,
  })
  readonly startTime: string;
  @Prop({
    type: String,
  })
  readonly endTime: string;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly items: CalendarItem[];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly backgroundItems: CalendarBackgroundItem[];

  // SLOT sizes

  @Prop({
    type: Boolean,
  })
  readonly xxsSlot: boolean;
  @Prop({
    type: Boolean,
  })
  readonly xsSlot: boolean;
  @Prop({
    type: Boolean,
  })
  readonly smSlot: boolean;
  @Prop({
    type: Boolean,
  })
  readonly mdSlot: boolean;
  @Prop({
    type: Boolean,
  })
  readonly lgSlot: boolean;
  @Prop({
    type: Boolean,
  })
  readonly xlSlot: boolean;
  @Prop({
    type: Boolean,
  })
  readonly xxlSlot: boolean;

  // DATA
  calendarKey = 99;
  // LIFECYCLE
  // created(){}
  mounted() {
    this.addAllEventsToCalendar();
  }

  // updated(){}
  // destroyed(){}
  // COMPUTED
  get slotSizeClass(): string {
    if (this.xxsSlot) {
      return 'xxs-slot';
    }
    if (this.xsSlot) {
      return 'xs-slot';
    }
    if (this.smSlot) {
      return 'sm-slot';
    }
    if (this.mdSlot) {
      return 'md-slot';
    }
    if (this.lgSlot) {
      return 'lg-slot';
    }
    if (this.xlSlot) {
      return 'xl-slot';
    }
    if (this.xxlSlot) {
      return 'xxl-slot';
    }

    return 'md-slot';
  }
  get changeDetectorStr(): string {
    return [
      this.date,
      this.disableEdit,
      this.disableDragAndDrop,
      this.disableResize,
      this.disableSelect,
      this.disableOverlap,
      this.dayMinWidth,
      this.slotDuration,
      this.startTime,
      this.endTime,
      this.slotSizeClass,
    ].join('__');
  }
  get calendarOptions(): CalendarOptions {
    return {
      plugins: [resourceTimeGridPlugin, interactionPlugin, scrollGrid],
      schedulerLicenseKey: process.env.VUE_APP_FULLCALENDAR_LICENCE_KEY,
      headerToolbar: {
        left: '',
        center: '',
        right: '',
      },
      initialView: 'timeGridWeek',
      initialEvents: this.allEvents, // alternatively, use the `events` setting to fetch from a feed
      initialDate: this.calendarInitialDate,
      viewDidMount: this.gotoCurrentDate,
      eventStartEditable: this.eventStartEditable,
      eventDurationEditable: this.eventDurationEditable,
      selectable: this.selectable,
      selectMirror: true,
      // dayMaxEvents: true,
      weekends: true,
      unselectAuto: false,
      select: this.handleDateSelect,
      selectOverlap: this.allowOverlap,
      eventClick: this.handleEventClick,
      eventsSet: this.handleEventsSet,
      eventDrop: this.handleEventDrop,
      eventResize: this.handleEventResize,
      eventDidMount: this.onEventDidMount,
      eventOverlap: this.allowOverlap,
      datesAboveResources: true,
      dayMinWidth: this.calendarDayMinWidth,
      allDaySlot: false,
      slotMinTime: this.slotMinTime,
      slotMaxTime: this.slotMaxTime,
      eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit',
        omitZeroMinute: false,
        hour12: false,
        meridiem: false,
      },
      slotLabelFormat: {
        hour: '2-digit',
        minute: '2-digit',
        omitZeroMinute: false,
        hour12: false,
        meridiem: false,
      },
      slotDuration: this.calendarSlotDuration,
      height: 'auto',
      stickyHeaderDates: 'auto',
      nowIndicator: true,
      weekNumberCalculation: 'ISO',
      locale: this.lang,
      // eventChange: this.handleEventChange,
      /* you can update a remote database when these fire:
    eventAdd:
    eventChange:
    eventRemove:
    */
    };
  }
  set calendarOptions(value) {
    this.calendarOptions = value;
  }

  get selectable(): boolean {
    return !this.disableSelect;
  }
  get eventStartEditable(): boolean {
    return !this.disableDragAndDrop && !this.disableEdit;
  }
  get eventDurationEditable(): boolean {
    return !this.disableResize && !this.disableEdit;
  }
  get allowOverlap(): boolean {
    return !this.disableOverlap;
  }

  get calendarDayMinWidth(): number {
    return this.dayMinWidth;
  }
  get calendarInitialDate(): string {
    return this.date || moment().format('YYYY-MM-DD');
  }

  get slotMinTime() {
    if (this.startTime) {
      return this.startTime;
    }
    return this.$store.getters['centerSettings/centerSettings']?.default_start_hour;
  }

  get slotMaxTime() {
    if (this.endTime) {
      return this.endTime;
    }
    return this.$store.getters['centerSettings/centerSettings']?.default_end_hour;
  }

  get calendarSlotDuration() {
    // TODO move this to props
    const slotDuration =
      this.slotDuration ||
      this.$store.getters['centerSettings/centerSettings']?.default_slot_duration ||
      30;
    const hours = Math.floor(slotDuration / 60);
    const minutes = slotDuration % 60 < 10 ? `0${slotDuration % 60}` : slotDuration % 60;

    return `${hours}:${minutes}:00`;
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get allEvents() {
    return this.items.concat(this.backgroundItems);
  }

  // METHODS
  onEventDidMount(info) {
    this.$emit('event-mounted', info);
    if (this.withPopover) {
      const contentStr = this.getPopoverContentStr(info);
      const titleStr = this.getPopoverTitleStr(info);
      new PropPopover({
        propsData: {
          titleHtml: titleStr,
          bodyHtml: contentStr,
          placement: 'auto',
          customClass: 'calendar-popover',
          delay: 500,
          offset: 0,
          triggers: 'hover',
          html: true,
          target: info.el,
        },
      }).$mount();
    }
  }

  gotoCurrentDate() {
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.getApi().gotoDate(this.calendarInitialDate);
    }
  }

  addAllEventsToCalendar() {
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.getApi().unselect();
      this.refreshCalendar();
      this.$emit('rerender-events', this.allEvents);
    }
  }

  refreshCalendar() {
    this.calendarKey++;
  }

  handleDateSelect(e) {
    // console.log('handleDateSelect', e);
    this.$emit('date-selected', e);
  }
  handleEventClick(e) {
    // console.log('handleEventClick', e);
    this.$emit('event-clicked', e);
  }
  handleEventsSet(e) {
    // console.log('handleEventsSet', e);
    this.$emit('events-set', e);
  }
  handleEventDrop(e) {
    // console.log('handleEventDrop', e);
    this.$emit('event-droped', e);
  }
  handleEventResize(e) {
    // console.log('handleEventResize', e);
    this.$emit('event-resized', e);
  }
  // WATCHERS
  @Watch('items', { deep: true })
  onItemsChange(val) {
    if (val) {
      this.addAllEventsToCalendar();
    }
  }
  @Watch('backgroundItems', { deep: true })
  onBackgroundItemsChange(val) {
    if (val) {
      this.addAllEventsToCalendar();
    }
  }
  @Watch('changeDetectorStr', { deep: true })
  onChangeDetectorStrChange(val) {
    this.refreshCalendar();
  }
}
